import { usePlaygroundSettings } from '@/hooks/useSwr';
import { useLocalStorageState } from '@/utils/use-local-storage-state';

import { DEFAULT_CONFIG_ID_LOCAL_STORAGE_KEY } from '../../constants';

export const useDefaultPromptConfig = () => {
  const [defaultConfigId] = useLocalStorageState(
    DEFAULT_CONFIG_ID_LOCAL_STORAGE_KEY,
    undefined
  );

  const { data: configs, isLoading: isConfigsLoading } =
    usePlaygroundSettings();

  const defaultConfig = configs?.find(
    (config) => config.id === defaultConfigId
  );

  return { defaultConfig, defaultConfigId, isLoading: isConfigsLoading };
};
